import React from 'react';
import clipboard from '../utils/clipboard.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function UserQR({showQR, closeQR, qrInfo}) {
	const popupAnimationMs = 300;
	const {shouldRender, isClosing} = usePopupAnimation(showQR, popupAnimationMs);

	return (
		<>
			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<div className="popup_content_in_head">
							<div className="popup_content_in_head_in">
								{qrInfo?.data?.LASTNAME} {qrInfo?.data?.FIRSTNAME} {qrInfo?.data?.NICKNAME !== '' ? '(' + qrInfo?.data?.NICKNAME + ')' : ''}
							</div>
							<img
								alt=""
								className="popup_content_in_head_in-close"
								onClick={() => {
									closeQR(false);
								}}
							/>
						</div>
						<div className="popup_content_in_body">
							<div className="popup_content_in_body_in">
								<div
									className="qrcode cr_p"
									onClick={() => clipboard(qrInfo?.VCARD)}
									dangerouslySetInnerHTML={{__html: qrInfo?.QR || ''}}
								/>
								<div className="zero h1" />
								<div className="" dangerouslySetInnerHTML={{__html: qrInfo?.VCARD2 || ''}} />
								<div className="zero h1" />
								<button
									className="button"
									onClick={() => {
										clipboard(qrInfo?.VCARD);
									}}
								>
									Zkopírovat do schránky
								</button>
								<div className="zero h1" />
							</div>
						</div>
						<div className="popup_content_in_foot">
							<div className="popup_content_in_foot_in">
								<button
									className="button"
									onClick={() => {
										closeQR(false);
									}}
								>
									Zpět
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
